import { WeaponButton } from '@components/arsenal/weapons/WeaponButton';
import { WeaponInfo } from '@components/arsenal/weapons/WeaponInfo';
import { ArsenalHeader } from '@components/arsenal/ArsenalHeader';
import { Upgrade } from '@components/arsenal/upgrade/Upgrade';
import { useHistoryInterceptor } from '@helpers/history';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';
import { useState } from 'react';

export function ArsenalWeapons() {
  const [upgradeWeapon, setUpgradeWeapon] = useState('');
  const [weapon, setWeapon] = useState('');

  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Weapons' });
  const { userData } = useAppStore();

  useHistoryInterceptor(() => {
    if (upgradeWeapon) { setUpgradeWeapon(''); return true; }
    if (weapon) { setWeapon(''); return true; }
    return false;
  }, { disabled: !upgradeWeapon && !weapon });

  const weaponsArray = Shared.weaponsData
    .filter(c => userData.weapons.some(ch => ch.key === c.key))
    .sort((a, _b) => {
      const isActive = userData.weapons.some(c => c.key === a.key && c.active);
      if (isActive) return -1;
      return 1;
    });

  if (weapon) return <WeaponInfo onBack={() => setWeapon('')} weapon={weapon} />;
  if (upgradeWeapon) return <Upgrade onBack={() => setUpgradeWeapon('')} value={upgradeWeapon} type="weapon" />;

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <ArsenalHeader description={t('description')} title={t('title')} bg="weapons.avif" />

      <div className="flex-1 overflow-y-auto">
        <div className="grid grid-cols-2 lg:grid-cols-3">
          {weaponsArray.map((w, index) => (
            <WeaponButton
              onUpgrade={() => setUpgradeWeapon(w.key)}
              onView={() => setWeapon(w.key)}
              index={index}
              key={index} weapon={w}
            />
          ))}
        </div>
      </div>
    </div>
  );
}